import Grid from "@mui/material/Grid2";
import ProductCardCarrousel from "@/components/product-cards/product-card-carrousel";

export default function ProductsGridView({
  products
}) {
  return <Grid container spacing={1}>
    {products.map(product =>
      <Grid item size={{
        xl: 2,
        md: 2,
        sm: 4,
        xs: 6
      }} key={product.id}>

        <ProductCardCarrousel type="default" product={product} />
      </Grid>)}
  </Grid>;
}